import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { MatDialog } from '@angular/material/dialog';
import { UsuarioMeusDadosModal } from '../usuario-meus-dados-modal/usuario-meus-dados-modal.component';

@Component({
  selector: 'usuario-perfil', 
  templateUrl: './usuario-perfil.component.html',
  styleUrls: ['./usuario-perfil.component.scss']
})
export class UsuarioPerfilComponent implements OnInit {

  public usuario:any = {};
  
  constructor(
    private storage: StorageService,
    private usuarioService: UsuarioService,
    private dialog: MatDialog  
  ){ }

  /***
   * 
   * Seta o usuário
   * 
   */
  setUsuario(){

    this.usuario = this.storage.getUsuario();     
    
  }
  /**
   * 
   * Open dados
   * 
   */
  _openDados(){ 

    this.dialog.open(UsuarioMeusDadosModal,{
      width: "500px",
      height: "auto",
      disableClose: true,
      data: {
        usuario: this.usuario
      }
    });

  }
  /**
   * 
   * On Data
   * 
   */
  onData(){

    this.usuarioService.emitUsuarioLogin.subscribe(usuario => {

      this.usuario = usuario; 

    });

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{
    this.setUsuario();
    this.onData();
  }

}
